var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDerivations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9461 16.7695H10.6661C9.58358 16.7695 8.70605 17.647 8.70605 18.7295V40.2595C8.70605 41.342 9.58358 42.2195 10.6661 42.2195H40.9461C42.0285 42.2195 42.9061 41.342 42.9061 40.2595V18.7295C42.9061 17.647 42.0285 16.7695 40.9461 16.7695Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.947 44.2322H10.667C9.60613 44.2322 8.58877 43.8108 7.83862 43.0606C7.08848 42.3105 6.66699 41.2931 6.66699 40.2322V18.7422C6.66699 17.6813 7.08848 16.6639 7.83862 15.9138C8.58877 15.1636 9.60613 14.7422 10.667 14.7422H40.947C42.0079 14.7422 43.0252 15.1636 43.7754 15.9138C44.5255 16.6639 44.947 17.6813 44.947 18.7422V40.2722C44.9365 41.3261 44.5104 42.3333 43.7614 43.0748C43.0123 43.8163 42.001 44.2323 40.947 44.2322ZM10.707 18.7822V40.2722H40.947V18.7822H10.707Z",
    fill: "#28AEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4373 15.6H32.4373V9H18.7373V15.6H14.7373V8.80002C14.7373 7.79393 15.1362 6.82887 15.8467 6.11652C16.5572 5.40416 17.5211 5.00265 18.5272 5H32.6472C33.6533 5.00265 34.6173 5.40416 35.3278 6.11652C36.0382 6.82887 36.4373 7.79393 36.4373 8.80002V15.6Z",
    fill: "#28AEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.0471 27.5H19.5771V31.5H32.0471V27.5Z",
    fill: "#28AEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.8076 23.2617H23.8076V35.7317H27.8076V23.2617Z",
    fill: "#28AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDerivations);
export default __webpack_public_path__ + "static/media/IconDerivations.f14aeb237d9360903f9d482bdff82863.svg";
export { ForwardRef as ReactComponent };